import { Table } from "@/features/Table";
import { useBulkDeleteControls } from "@/features/Edit/useBulkDeleteControls";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type S3Transaction, porfolios_columns } from "./columns";
import {
  type FilterS3TransactionsSchema,
  FilterS3Transactions,
} from "./filter";

export const S3TransactionsTable = () => {
  const { selectionActions, modal } = useBulkDeleteControls<S3Transaction>({
    client: Clients.S3,
    table_name: Tables.S3_TRANSACTIONS,
    resourceLabel: "Transactions",
  });

  return (
    <>
      <Table<S3Transaction, FilterS3TransactionsSchema>
        label="Transactions"
        client={Clients.S3}
        table_name={Tables.S3_TRANSACTIONS}
        columns={porfolios_columns}
        filter={<FilterS3Transactions />}
        actions={[
          {
            label: "actions.new",
            route: `${Clients.S3}/${Tables.S3_TRANSACTIONS}/new`,
          },
        ]}
        enableRowSelection
        selectionActions={selectionActions}
      />
      {modal}
    </>
  );
};
